(function($) {

  $(document).ready(function() {
    if ($.fn.matchHeight) {
      // Match Height
      $('.partner').matchHeight();
    }
  });

})(jQuery);
